import { ComparableProperty } from "@cma/presentation-generation-logic";
import { Listing } from "../types/Listing";
import { MapPropertyItemDto } from "@shared/apis/sidekick/generated";

export const convertListingToComparableProperty = (
  listing: Listing
): ComparableProperty => {
  return {
    id: listing.id,
    mlsId: listing.mlsId,
    mlsSource: listing.mlsSource,
    addressLine1: listing.addressLine1,
    addressLine2: listing.addressLine2,
    city: listing.city,
    area: undefined,
    neighborhood: listing.neighborhood,
    propertyType: listing.propertyType?.propertyType,
    type: "comparable-active",
    listingStatus: listing.listingStatus?.listingStatus || null,
    yearBuilt: listing.yearBuilt,
    livingSpace: listing.internalSize,
    beds: listing.numBedrooms || listing.bedroomCount,
    baths: listing.numBathrooms || listing.bathroomCount,
    lotSize: listing.lotSize,
    garageParkingSpaces: listing.parkingGarageSpaces,
    hoaFees: listing.hoaMonthlyFee,
    hoaFee: listing.hoaFee,
    latitude: listing.latitude,
    longitude: listing.longitude,
    listDate: listing.listDate ? new Date(listing.listDate) : undefined,
    photos:
      listing.photos?.map((url, index) => ({
        id: `${listing.id}-photo-${index}`,
        url: url,
        caption: undefined,
        thumbnail: undefined,
      })) || [],
    zipCode: listing.zipCode,
    state: listing.state,
    costPerInternalSqFt: listing.costPerInternalSqFt,
    currentPrice: listing.currentPrice,
    soldPrice: listing.soldPrice,
    soldDate: undefined,
    hasDoormanAttendance: listing.hasDoormanAttendance,
    isLease: listing.isLease,
    roomsTotal: undefined,
    recurringCosts: listing.hoaMonthlyFee
      ? [
          {
            label: "HOA Fee",
            value: listing.hoaMonthlyFee,
            frequency: "monthly",
            type: "hoa",
          },
        ]
      : null,
    flipTaxRemarks: undefined,
    description: listing.description,
  };
};

export const convertMapListingToComparableProperty = (
  listing: MapPropertyItemDto
): ComparableProperty => {
  return {
    id: listing.id,
    mlsId: listing.mlsId,
    mlsSource: listing.mlsSource,
    addressLine1: listing.addressLine1,
    addressLine2: listing.addressLine2,
    city: listing.city,
    // neighborhood: listing.neighborhood,
    propertyType: listing.propertyType?.propertyType,
    type: "comparable-active",
    listingStatus: listing.listingStatus?.listingStatus || null,
    livingSpace: listing.internalSize,
    beds: listing.numBedrooms,
    baths: listing.numBathrooms,
    latitude: listing.latitude,
    longitude: listing.longitude,
    photos: [
      {
        id: `${listing.id}-photo`,
        url: listing.coverPhotoUrl,
        caption: undefined,
        thumbnail: undefined,
      },
    ],
    zipCode: listing.zipCode,
    state: listing.state,
    currentPrice: listing.currentPrice,
  };
};
